export const initialise = () => {
    const widgets = document.querySelectorAll('.shareWidget');
    widgets.forEach(widget => {
        const heading = document.createElement('h3');
        const label = widget.querySelector('label');
        const labelText = label?.textContent || 'Share this vacancy';
        heading.textContent = labelText;
        label?.remove();
        widget.prepend(heading);
    });
};